<script>
  import {IMAGES} from '@/const/images';

  export let user = '';

</script>

<style>
  .logo-user {
    display: flex;
    align-items: center;
    font-size: 20px;
  }
  @media screen and (max-width: 640px) {
    .logo-user {
      display: none;
    }
  }
</style>

<div class="logo-user">
  <img height="26" class="logo" alt="Logo" src={IMAGES.LOGO_LIGHT} />
  <i class="iconfont f24 mr8 ml8">&#xe614;</i>
  <div>{user}</div>
</div>
